import { HttpError, useOne } from '@refinedev/core';
import { BackgroundProcess } from 'src/data-capture/hooks/file-uploads/types';

export enum MeetingNoteStatus {
  READY = 'READY',
  MEETING_NOTE_PROCESSING = 'MEETING_NOTE_PROCESSING',
  TRANSCRIPTION_PROCESSING = 'TRANSCRIPTION_PROCESSING',
  FAILED = 'FAILED',
  NOT_CREATED = 'NOT_CREATED',
}

type MeetingNote = {
  status: MeetingNoteStatus;
  markdownContent?: string;
  templatisedFileId?: number;
  templateId?: string;
  backgroundProcess?: BackgroundProcess;
};

type UseCalendarEventMeetingNoteResult = {
  meetingNote: MeetingNote | undefined;
  isLoading: boolean;
  isError: boolean;
  error: HttpError | null;
  refetch: () => void;
};

export const useCalendarEventMeetingNote = (
  eventId: string,
  { enabled }: { enabled: boolean },
): UseCalendarEventMeetingNoteResult => {
  const { data, isLoading, isError, error, refetch } = useOne<MeetingNote>({
    resource: `calendar-events/${eventId}/meeting-notes`,
    id: '',
    queryOptions: {
      enabled: enabled,
      retry: false,
      refetchInterval: data => {
        const status = data?.data?.backgroundProcess?.status;
        if (status === 'PENDING' || status === 'PROCESSING') {
          return 2000;
        }
        return false;
      },
    },
  });

  return {
    meetingNote: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
